import { edmCampaign } from '@bingads-webui/edm-campaign';

// the magic date is for bidata, but useless for this request
const magicDate = '9/30/2015';

export const loadKeywords = (cid, aid, campaignId, adGroupId, top) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups.$withKey(adGroupId)
    .Keywords.get({
      $top: top,
      $count: true,
      startDate: magicDate,
      endDate: magicDate,
    }).toPromise();
